import { isAndroid } from 'shared/constants/platform';

export const getKeyboardVerticalOffset = (
  height: number,
  isKeyboardVisible?: boolean,
) => {
  if (isAndroid) {
    return isKeyboardVisible ? 100 : 60;
  }
  return height < 700 ? 60 : 100;
};
